import React from 'react';
import Table from '../../components/common/Table';
import { InvoiceLineItemDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface InvoiceLineItemTableProps {
  data: InvoiceLineItemDTO[];
  handleEdit: (row: InvoiceLineItemDTO) => void;
  handleDelete: (row: InvoiceLineItemDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const InvoiceLineItemTable: React.FC<InvoiceLineItemTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Description',
          key: 'description',
        },

        {
          label: 'Quantity',
          key: 'quantity',
        },

        {
          label: 'Value',
          key: 'priceIncl',
          render: (row: InvoiceLineItemDTO) => (
            <div className="flex flex-col">
              <span>R {row.priceIncl?.toFixed(2)}</span>
            </div>
          ),
        },
        
        {
          label: 'VAT',
          key: 'priceTax',
          render: (row: InvoiceLineItemDTO) => (
            <div className="flex flex-col">
              <span>R {row.priceTax?.toFixed(2)}</span>
            </div>
          ),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      allowPaging={false}
      isLoading={isLoading}
    />
  );
};

export default InvoiceLineItemTable;
